import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { shareReplay } from 'rxjs/operators';
import { WebPaths } from '@partner/shared/SharedConstants';
import { ExecutiveSnapshotFacade } from './executive-snapshot.facade';
import { HomeFacade } from './home.facade';
import { HomeData } from './home.model';
import { DashboardWidgetData } from '../../domain/model/dashboard.model';
import { ExecutiveSnapshotVm, ExecutiveSnapshotVmState } from '../../domain/model/executive-snapshot.model';

@Component({
    selector: 'ifbp-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    providers: [HomeFacade, ExecutiveSnapshotFacade],
    standalone: false
})
export class HomeComponent implements OnInit {
  /** Shared: the greeting and the widget section each hold an async pipe, but one request is made. */
  data$: Observable<HomeData>;
  /** Independent of `data$`: each section renders while the other loads or fails. */
  snapshot$: Observable<ExecutiveSnapshotVm>;
  readonly WebPaths = WebPaths;
  readonly SnapshotState = ExecutiveSnapshotVmState;

  constructor(
    private readonly homeFacade: HomeFacade,
    private readonly executiveSnapshotFacade: ExecutiveSnapshotFacade,
  ) { }

  ngOnInit(): void {
    this.data$ = this.homeFacade.getHomeData$().pipe(shareReplay({ bufferSize: 1, refCount: true }));
    this.snapshot$ = this.executiveSnapshotFacade.vm$;
  }

  /** Widgets carry no id; the title is the only stable key the API sends. */
  trackByWidget(index: number, widget: DashboardWidgetData): string | number {
    return widget?.title ?? index;
  }
}
